export default __webpack_public_path__ + "defaultprofileheader.50b090a.png";